import type { Reducer } from 'react';
import {
    CLEAR_ROLE_ASSUMPTION,
    NO_DEAL_ASSOCIATED_WITH_DEALERSHIPS,
    SAVE_ROLE_ASSUMPTED_USERNAME,
    START_ROLE_ASSUMPTION,
    VALIDATE_ROLE_ASSUMPTION_USER_FAILURE,
    VALIDATE_ROLE_ASSUMPTION_USER_REQUEST,
    VALIDATE_ROLE_ASSUMPTION_USER_SUCCESS,
    RESET_VALIDATION_STATE
} from './actions';
import { ApiRequestStatus } from '@makemydeal/dr-shared-types';
import type { RoleAssumptionState } from '../types/StateTree';
import { getInitialRoleAssumptionState } from './initialState';

export type RoleAssumptionReducer = Reducer<RoleAssumptionState, any>;

export const roleAssumptionReducer: Reducer<RoleAssumptionState, any> = (
    state: RoleAssumptionState = { ...getInitialRoleAssumptionState() },
    action: any
) => {
    const { type, userName, isNoDealAssociated } = action;

    switch (type) {
        case SAVE_ROLE_ASSUMPTED_USERNAME: {
            return {
                ...state,
                assumedUserName: userName
            };
        }
        case CLEAR_ROLE_ASSUMPTION: {
            return {
                ...state,
                assumedUserName: '',
                requestStatus: ApiRequestStatus.Idle,
                isRoleAssumptionStarted: false
            };
        }
        case START_ROLE_ASSUMPTION: {
            return {
                ...state,
                isRoleAssumptionStarted: true
            };
        }
        case NO_DEAL_ASSOCIATED_WITH_DEALERSHIPS: {
            return {
                ...state,
                isNoDealAssociated
            };
        }
        case VALIDATE_ROLE_ASSUMPTION_USER_REQUEST: {
            return {
                ...state,
                requestStatus: ApiRequestStatus.Loading
            };
        }
        case VALIDATE_ROLE_ASSUMPTION_USER_SUCCESS: {
            return {
                ...state,
                isValidRoleAssumptionUser: action.payload?.success,
                requestStatus: ApiRequestStatus.Success
            };
        }
        case VALIDATE_ROLE_ASSUMPTION_USER_FAILURE: {
            return {
                ...state,
                isValidRoleAssumptionUser: false,
                requestStatus: ApiRequestStatus.Error
            };
        }
        case RESET_VALIDATION_STATE: {
            return {
                ...state,
                isValidRoleAssumptionUser: true,
                requestStatus: ApiRequestStatus.Idle
            };
        }
        default: {
            return state;
        }
    }
};
